const dateToString = (date) => {
  if (!date) return '';

  const pad = (n) => n.toString().padStart(2, '0');

  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const HH = pad(date.getHours());
  const MM = pad(date.getMinutes());
  const SS = pad(date.getSeconds());

  return `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}`;
}

export const isoToDateString = (iso: string) => {
  const date = new Date(iso);
  return dateToString(date);
}
